/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions, react/no-danger */
import React, {
  useState,
  useMemo,
  useCallback,
  useRef,
  useEffect,
} from 'react';
import { Copy, Trash, Check, Pencil, LockOpen, Lock } from '@saleshandy/icons';
import { Spinner } from 'react-bootstrap';
import { t } from 'i18next';
import InlineMentionEditor from '../../../../../prospect-kanban/Inline-mention-editor';
import Input from '../../../../../../../../shared/design-system/components/input';
import { UnpinGrey } from '../../../../../../../../shared/svg/unpin-grey';
import { Images } from '../../../../../../../../shared/app-constants';
import { Dot } from '../../../../../../../../shared/svg/dot';
import { OverlayTooltip } from '../../../../../../../../shared/design-system/components/overlay';
import { LinkGrey } from '../../../../../../../../shared/svg/link-grey';
import {
  accessibleOnClick,
  executeOnRequestStatus,
  formatDateTimeWithUserTimezone,
  formatNoteTimestamp,
  getIsRequestPending,
  redirectWithNewTab,
  SubscriptionPlans,
} from '../../../../../../../../shared/utils';
import { PinBlue } from '../../../../../../../../shared/svg/pin-blue';
import ConfirmationModal from '../../../../../../../../shared/components/confirmation-modal';
import {
  AttachmentType,
  AttachmentUploadStatus,
  AttachmentMetaDataType,
} from '../../../../../../../../shared/editor/types';
import { Notes, NotesListProps } from './utils/types';
import {
  GetProspectNotesList,
  NoteItem,
  visibility,
} from '../../../../../../types';
import { ProspectNotePinUnpinActionType } from '../../../../../../enums/prospect';
import { RequestStatus } from '../../../../../../../../shared/enums/request-status';
import toaster, { Theme } from '../../../../../../../../shared/toaster';
import { InputIconConfig } from '../../../../../../../../shared/design-system/components/input/types';
import NotesListTabSkeleton from './notes-list-tab-skeleton';
import NoProspectDetailResultScreen from '../../../no-prospect-detail-result-screen/no-prospect-detail-result-screen';
import EmailPreviewContent from '../../../../../../../../shared/components/email-preview/email-preview-content';
import { convertHtmlToPlainTextForCopy } from '../email-list-tab/utils/helper';
import { getStepIcon } from '../../../../../../../tasks/components/tasks-content/utils/step-icon';

const NotesListTab: React.FC<NotesListProps> = ({
  selectedProspectId,
  handleSendAttachmentUploadRequest,
  handleSendDeleteAttachmentRequest,
  handleResetUploadAttachmentRequest,
  handleResetDeleteAttachmentRequest,
  fetchNotesProspectList,
  createProspectNote,
  resetCreateProspectNotesListRequests,
  deleteProspectNotesRequest,
  prospectNotePinRequests,
  resetDeleteProspectNoteRequests,
  resetProspectNotePinRequests,
  updateProspectNotesRequest,
  resetGetProspectNotesRequests,
  updateProspectNotesVisibilityRequest,
  resetUpdateProspectNoteVisibilityRequest,
  resetUpdateProspectNote,

  uploadAttachmentRequestStatus,
  uploadAttachmentRequestError,
  uploadedAttachment,
  deleteAttachmentRequestStatus,
  deleteAttachmentRequestError,
  deletedAttachmentId,
  createProspectNoteRequestStatus,
  createProspectNoteRequestMessage,
  createProspectNoteResponse,
  updateProspectNoteResponse,
  deleteProspectNotesRequestsStatus,
  prospectNotesListingResponse,
  getProspectNotesRequestStatus,
  getProspectNotesPinRequestStatus,
  getProspectNotesPinRequestMessage,
  getUpdateProspectNoteVisibiityRequestStatus,
  updateProspectNoteVisibilityResponse,
  scrollContainerRef: externalScrollContainerRef,
  uploadedAttachmentRes,
  updateProspectNoteRequestState,
  loginUserId,
  planCode,
  onActivityChange,
  fetchNotes,
  onNoteChange,
  activeTab,
  userTimezone,
  onTaskChange,
  prospectActivityCount,
  editProspectAcitivityCount,
}) => {
  const url = window.location;
  const [editorValue, setEditorValue] = useState<string>('');
  const [values, setValues] = useState<string>('');
  const [selectedVisibilityKey, setSelectedVisibilityKey] = useState<string>(
    'public',
  );
  const [clickedAddNewNote, setClickedAddNewNote] = useState<boolean>(false);

  const [noteList, setNoteList] = useState<GetProspectNotesList | null>(null);
  const [copiedNoteId, setCopiedNoteId] = useState<string | null>(null);
  const [copiedLinkNoteId, setCopiedLinkNoteId] = useState<string | null>(null);
  const [showConfimationModal, setShowConfimationModal] = useState<boolean>(
    false,
  );
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [
    selectedNoteForVisibilityChange,
    setSelectedNoteForVisibilityChange,
  ] = useState<NoteItem | null>(null);
  const [notePendingDelete, setNotePendingDelete] = useState<Notes | null>(
    null,
  );
  const [editingNoteId, setEditingNoteId] = useState<string | null>(null);
  const [editingNoteValue, setEditingNoteValue] = useState<string>('');
  const [attachments, setAttachments] = useState<AttachmentType[]>([]);
  const [editingNoteAttachments, setEditingNoteAttachments] = useState<
    AttachmentType[]
  >([]);
  const [attachmentsMeta, setAttachmentsMeta] = useState<
    AttachmentMetaDataType[]
  >([]);
  const [editingNoteAttachmentsMeta, setEditingNoteAttachmentsMeta] = useState<
    AttachmentMetaDataType[]
  >([]);
  const [expandedNoteIds, setExpandedNoteIds] = useState<Set<string>>(
    new Set(),
  );
  const [notesNeedingTruncation, setNotesNeedingTruncation] = useState<
    Set<string>
  >(new Set());
  const [highlightedNoteIds, setHighlightedNoteIds] = useState<Set<string>>(
    new Set(),
  );
  const [draftSavedForNotes, setDraftSavedForNotes] = useState<boolean>(false);
  const [showError, setShowError] = useState('');
  const [showDraftSavedMessage, setShowDraftSavedMessage] = useState(false);
  // Track last note params we highlighted from URL so we don't re-highlight on tab/action changes (ref avoids effect re-run so 2s timeout isn't cleared)
  const lastProcessedNoteParamsFromUrlRef = useRef<string | null>(null);
  const contentRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const internalScrollContainerRef = useRef<HTMLDivElement>(null);
  const scrollContainerRef =
    externalScrollContainerRef || internalScrollContainerRef;
  const isInitialRenderRef = useRef<boolean>(true);
  const [previousData, setPreviousData] = useState<{
    content: string;
    visibility: string;
    attachmentIds: number[];
  } | null>(null);
  const [currentData, setCurrentData] = useState<{
    content: string;
    visibility: string;
    attachmentIds: number[];
  } | null>(null);
  const [isFinalSaveInProgress, setIsFinalSaveInProgress] = useState<boolean>(
    false,
  );
  const [blockedDraftText, setBlockedDraftText] = useState<boolean>(false);

  // Remove noteId and selectedIds from URL query params without refreshing (same as email removeEmailIdFromUrl)
  const removeNoteIdFromUrl = useCallback(() => {
    if (typeof window === 'undefined') return;
    const queryParams = new URLSearchParams(window?.location?.search);
    let changed = false;
    if (queryParams?.has('noteId')) {
      queryParams?.delete('noteId');
      changed = true;
    }
    if (queryParams?.has('selectedIds')) {
      queryParams?.delete('selectedIds');
      changed = true;
    }
    if (changed) {
      const newUrl = queryParams?.toString()
        ? `${window?.location?.pathname}?${queryParams?.toString()}`
        : window?.location?.pathname;
      window?.history?.replaceState(null, '', newUrl);
    }
  }, []);

  // Helper to keep the notes search term in the URL so it survives reloads/navigation
  const updateNotesSearchInUrl = useCallback((search: string) => {
    try {
      const currentUrl = new URL(window.location.href);
      if (search.trim()) {
        currentUrl.searchParams.set('search', search.trim());
      } else {
        currentUrl.searchParams.delete('search');
      }
      window.history.replaceState({}, '', currentUrl.toString());
    } catch (e) {
      // Fail silently if URL API isn't available for some reason
    }
  }, []);

  // Determine loading state from request status
  const isLoadingMoreNotes =
    getProspectNotesRequestStatus === RequestStatus.Pending;

  // Helper function to calculate content size in bytes
  const getContentSizeInBytes = (content: string): number =>
    new TextEncoder().encode(content).length;

  // Check if content exceeds 2MB (2 * 1024 * 1024 bytes = 2097152 bytes)
  const isContentExceeds2MB = (content: string): boolean => {
    const sizeInBytes = getContentSizeInBytes(content);
    return sizeInBytes > 2 * 1024 * 1024;
  };

  useEffect(() => {
    setShowError('');
  }, []);

  // Handle draft save with 2 second delay
  useEffect(() => {
    // Don't save draft if final save is in progress or if no prospect selected
    // Also don't save draft if we're editing an existing note (only save when user clicks Save)
    if (currentData?.content === '') {
      setShowError('');
    }
    if (!selectedProspectId || isFinalSaveInProgress || editingNoteId) {
      return;
    }

    // If currentData is null, don't proceed
    if (currentData === null) {
      return;
    }

    // Compare previousData and currentData - if they match exactly, don't call API
    const attachmentIdsMatch =
      previousData &&
      previousData.attachmentIds.length === currentData.attachmentIds.length &&
      previousData.attachmentIds.every(
        (id, index) => id === currentData.attachmentIds[index],
      );
    if (
      previousData &&
      previousData.content === currentData.content &&
      previousData.visibility === currentData.visibility &&
      attachmentIdsMatch
    ) {
      // No changes, don't call API
      return;
    }

    // Set timeout for 2 seconds
    const timeoutId = setTimeout(() => {
      // Re-check conditions after delay
      // Don't save if final save is in progress
      if (isFinalSaveInProgress) {
        return;
      }

      // Re-check if currentData still exists (might have been cleared)
      if (!currentData) {
        return;
      }

      // Re-check if data still changed after 2 seconds
      const attachmentIdsStillMatch =
        previousData &&
        previousData.attachmentIds.length ===
          currentData.attachmentIds.length &&
        previousData.attachmentIds.every(
          (id, index) => id === currentData.attachmentIds[index],
        );
      if (
        previousData &&
        previousData.content === currentData.content &&
        previousData.visibility === currentData.visibility &&
        attachmentIdsStillMatch
      ) {
        // No changes after delay, don't call API
        return;
      }

      const createNoteRequestPending = getIsRequestPending(
        createProspectNoteRequestStatus,
      );
      const updateNoteRequestPending = getIsRequestPending(
        updateProspectNoteRequestState?.status,
      );

      if (createNoteRequestPending || updateNoteRequestPending) return;

      const draftNote = noteList?.draftNote;
      const trimmedContent = currentData.content?.trim() || '';

      // Check if content exceeds 2MB - if so, don't call draft API
      if (isContentExceeds2MB(currentData?.content || '')) {
        setShowError('Content size cannot exceed 2MB');
        return;
      }
      setShowError('');

      if (draftNote?.id) {
        // If draft note exists, update it (allow empty content to clear draft)
        updateProspectNotesRequest({
          noteId: Number(draftNote.id),
          content: currentData.content,
          visibility: currentData.visibility as visibility,
          attachmentIds: currentData.attachmentIds,
          status: 0,
        });
      } else {
        // If no draft note, only create new one if content is not empty
        // Prevent creating draft with empty content (API will fail)
        // eslint-disable-next-line no-lonely-if
        if (trimmedContent || currentData.attachmentIds.length > 0) {
          createProspectNote({
            prospectId: selectedProspectId,
            content:
              currentData.content === '' && attachments?.length !== 0
                ? `<div></div>`
                : currentData?.content,
            visibility: currentData.visibility as visibility,
            attachmentIds: currentData.attachmentIds,
            status: 0,
          });
        }
        // If content is empty and no attachment, don't create draft note
      }
    }, 2000);

    // Cleanup timeout on unmount or when dependencies change
    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(timeoutId);
    };
  }, [
    currentData,
    previousData,
    selectedProspectId,
    noteList?.draftNote,
    createProspectNote,
    updateProspectNotesRequest,
    isFinalSaveInProgress,
  ]);

  // Handle load more - fetch next page based on current pagination
  const handleLoadMoreNotes = useCallback(() => {
    if (
      !selectedProspectId ||
      !noteList?.pagination?.hasMore ||
      isLoadingMoreNotes
    ) {
      return;
    }

    // Calculate next skip value for pagination
    const currentSkip = noteList.pagination.skip || 0;
    const take = noteList.pagination.take || 20;
    const nextSkip = currentSkip + take;

    // Call fetchNotesProspectList with pagination params
    fetchNotesProspectList({
      taskId: selectedProspectId,
      skip: nextSkip,
      take,
    });
  }, [
    selectedProspectId,
    noteList?.pagination,
    isLoadingMoreNotes,
    fetchNotesProspectList,
  ]);

  // Scroll handler for infinite loading (similar to tasks-list-tab)
  const handleScroll = useCallback(() => {
    const container = scrollContainerRef?.current;
    if (!container) return;

    // Don't trigger load more if there are no notes
    if (!noteList?.notes || noteList.notes.length === 0) return;

    // Prevent duplicate calls
    if (isLoadingMoreNotes) return;

    // Don't load if there are no more notes
    if (!noteList?.pagination?.hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    // Load more when the user is 200px from the bottom
    const threshold = 200;
    const isNearBottom = scrollHeight - scrollTop <= clientHeight + threshold;

    if (isNearBottom && noteList?.pagination?.hasMore && !isLoadingMoreNotes) {
      handleLoadMoreNotes();
    }
  }, [
    scrollContainerRef,
    handleLoadMoreNotes,
    noteList?.notes,
    isLoadingMoreNotes,
    noteList?.pagination?.hasMore,
  ]);

  useEffect(() => {
    const container = scrollContainerRef?.current;
    if (!container) return;

    container.addEventListener('scroll', handleScroll, { passive: true });
    // eslint-disable-next-line consistent-return
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll, scrollContainerRef]);

  // Initialize notes with pinned status from state
  const notes = useMemo(
    () =>
      noteList?.notes?.map((note) => ({
        ...note,
        id: String(note.id),
        authorInitials: `${note.user?.firstName?.[0] || ''}${
          note.user?.lastName?.[0] || ''
        }`,
        authorName: `${note.user?.firstName || ''} ${
          note.user?.lastName || ''
        }`,
        content: note?.content || '',
        isPinned: !!note?.pinnedAt,
      })),
    [noteList],
  );

  const sortedNotes = useMemo(() => {
    if (!notes) return notes;

    return [...notes].sort((a, b) => {
      const aPinnedAt = a.pinnedAt ? new Date(a.pinnedAt).getTime() : 0;
      const bPinnedAt = b.pinnedAt ? new Date(b.pinnedAt).getTime() : 0;

      // Pinned notes first, latest pinnedAt on top
      if (aPinnedAt !== bPinnedAt) return bPinnedAt - aPinnedAt;

      // If both unpinned or same pinnedAt, fall back to createdAt (latest first)
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
  }, [notes]);

  const fetchDataAsPerView = sortedNotes;

  const handleCopyContent = useCallback(async (note: Notes) => {
    try {
      if (navigator?.clipboard?.writeText) {
        const text = convertHtmlToPlainTextForCopy(note?.content || '');
        await navigator.clipboard.writeText(text);
        setCopiedNoteId(note.id);
        setTimeout(() => {
          setCopiedNoteId(null);
        }, 2000);
      }
    } catch (err) {
      console.error('Failed to copy note content:', err);
    }
  }, []);

  const handleCopyLink = useCallback(async (note: Notes) => {
    try {
      if (navigator?.clipboard?.writeText) {
        const noteLink = `${url?.origin}/crm/list/${selectedProspectId}/notes?selectedIds=${note?.id}`;
        await navigator.clipboard.writeText(noteLink);
        setCopiedLinkNoteId(note?.id);
        setTimeout(() => {
          setCopiedLinkNoteId(null);
        }, 2000);
      }
    } catch (err) {
      console.error('Failed to copy note link:', err);
    }
  }, []);

  const handlePinToggle = useCallback(
    (noteId: string, pinnedAt: string) => {
      const isPinning = !pinnedAt;
      // Validate and convert noteId to number
      const noteIdNum = Number.parseInt(noteId, 10);

      if (Number.isNaN(noteIdNum)) {
        toaster.error('Invalid note ID', { theme: Theme.New });
        return;
      }

      setNoteList((prevNoteList) => {
        if (!prevNoteList?.notes) {
          return prevNoteList;
        }

        const noteIndex = prevNoteList.notes.findIndex(
          (note) => note.id === noteIdNum,
        );

        if (noteIndex === -1) {
          return prevNoteList;
        }

        const existingNote = prevNoteList.notes[noteIndex];
        const updatedNote: NoteItem = {
          ...existingNote,
          pinnedAt: isPinning ? new Date().toISOString() : null,
        };

        const updatedNotes = [...prevNoteList.notes];
        updatedNotes[noteIndex] = updatedNote;

        return {
          ...prevNoteList,
          notes: updatedNotes,
        };
      });

      prospectNotePinRequests(noteIdNum, {
        action: pinnedAt
          ? ProspectNotePinUnpinActionType.UnPin
          : ProspectNotePinUnpinActionType.Pin,
      });
    },
    [prospectNotePinRequests],
  );

  const handleStartEditingNote = useCallback((note: Notes) => {
    setEditingNoteId(String(note.id));
    setEditingNoteValue(note.content);
    // Reset attachments meta when starting to edit
    setEditingNoteAttachmentsMeta([]);
    // Transform attachments to AttachmentType format with all required fields
    if (note?.attachments && note.attachments.length > 0) {
      const transformedAttachments: AttachmentType[] = note.attachments.map(
        (attachment) => {
          const sizeNumber = attachment?.size
            ? parseInt(String(attachment.size), 10)
            : 0;
          const attachmentIdString =
            attachment?.id !== undefined &&
            attachment?.id !== null &&
            String(attachment.id);
          return {
            attachmentId: attachment?.id,
            attachmentIdentifier: attachmentIdString,
            status: AttachmentUploadStatus.Existing, // Existing attachments should have Existing status
            file: {
              name: attachment?.name || '',
              type: attachment?.mimeType || '',
              size: sizeNumber,
            },
            attachmentSize: sizeNumber,
          };
        },
      );
      setEditingNoteAttachments(transformedAttachments);
    } else {
      setEditingNoteAttachments([]);
    }
  }, []);

  const handleCancelEditing = useCallback(() => {
    // Cancel any uploading attachments before closing editor
    editingNoteAttachments.forEach((attachment) => {
      if (attachment.status === AttachmentUploadStatus.Uploading) {
        const attachmentMeta = editingNoteAttachmentsMeta.find(
          (item) =>
            item.attachmentIdentifier === attachment.attachmentIdentifier,
        );
        if (attachmentMeta?.source) {
          attachmentMeta.source.cancel('Upload has been cancelled.');
        }
      }
    });

    setEditingNoteId(null);
    setEditingNoteValue('');
    setEditingNoteAttachments([]);
    setEditingNoteAttachmentsMeta([]);
  }, [editingNoteAttachments, editingNoteAttachmentsMeta]);

  // Auto-scroll to editing note when edit is clicked
  useEffect(() => {
    if (!editingNoteId) return;

    // Use setTimeout to ensure DOM has updated with the editor
    const scrollTimeoutId = setTimeout(() => {
      const noteElement = document.querySelector(
        `[data-note-id="${editingNoteId}"]`,
      ) as HTMLElement;
      if (noteElement) {
        noteElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    }, 100);

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(scrollTimeoutId);
    };
  }, [editingNoteId]);

  const handleTaskNoteClick = useCallback(
    (note: NoteItem) => {
      // const taskHashId = 1234;
      const taskHashId = noteList?.notes?.find((item) => item?.id === note?.id)
        ?.task?.hashId;
      const taskNoteLink = `${url?.origin}/crm/list/${selectedProspectId}/tasks?taskId=${taskHashId}`;
      redirectWithNewTab(taskNoteLink);
    },
    [noteList?.notes],
  );

  // For Notes to Expand and Collapse
  const toggleNoteExpansion = useCallback((noteId: string) => {
    setExpandedNoteIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(noteId)) {
        newSet.delete(noteId);
      } else {
        newSet.add(noteId);
      }
      return newSet;
    });
  }, []);

  const handleSaveEditedNote = useCallback(() => {
    if (!editingNoteId) {
      return;
    }
    setBlockedDraftText(true);
    // Extract attachment IDs from editingNoteAttachments state
    const attachmentIds =
      editingNoteAttachments
        ?.map((attachment) => attachment?.attachmentId)
        .filter((id): id is number => id !== undefined && id !== null) || [];

    updateProspectNotesRequest({
      noteId: Number(editingNoteId),
      content: editingNoteValue,
      // Always include attachmentIds, even if empty array, so API knows to remove all attachments
      attachmentIds,
    });
  }, [
    editingNoteId,
    editingNoteValue,
    editingNoteAttachments,
    updateProspectNotesRequest,
  ]);

  const handleDeleteClick = useCallback(
    (note: Notes) => {
      setNotePendingDelete(note);
      setShowDeleteModal(true);
    },
    [setNotePendingDelete],
  );

  const handleCloseDeleteModal = useCallback(() => {
    setShowDeleteModal(false);
    setNotePendingDelete(null);
  }, []);
  const handleNoteDelete = useCallback(() => {
    if (!notePendingDelete?.id) {
      handleCloseDeleteModal();
      return;
    }

    const noteIdToDelete = Number(notePendingDelete.id);
    if (Number.isNaN(noteIdToDelete)) {
      handleCloseDeleteModal();
      return;
    }

    // Optimistically remove the note from the local list
    setNoteList((prevNoteList) => {
      if (!prevNoteList?.notes) return prevNoteList;

      const updatedNotes = prevNoteList.notes.filter(
        (note) => note.id !== noteIdToDelete,
      );

      return {
        ...prevNoteList,
        notes: updatedNotes,
      };
    });

    deleteProspectNotesRequest(noteIdToDelete);
    handleCloseDeleteModal();
  }, [
    notePendingDelete,
    deleteProspectNotesRequest,
    handleCloseDeleteModal,
    prospectActivityCount,
    editProspectAcitivityCount,
  ]);

  const openVisibilityModal = useCallback((note: NoteItem) => {
    setSelectedNoteForVisibilityChange(note);
    setShowConfimationModal(true);
  }, []);

  const getIconConfig = useCallback(
    (note: Notes) => {
      const isContentCopied = copiedNoteId === String(note?.id);
      const isLinkCopied = copiedLinkNoteId === String(note?.id);
      const pinnedAt = note?.pinnedAt;

      return [
        {
          label: 'link',
          icon: isLinkCopied ? (
            <Check
              width={16}
              height={16}
              className="notes-list-tab-icon-check"
            />
          ) : (
            <LinkGrey />
          ),
          tooltip: isLinkCopied ? 'Link Copied!' : 'Copy Note Link',
          onClick: () => handleCopyLink(note),
          // eslint-disable-next-line no-nested-ternary
          className: isLinkCopied
            ? 'copied'
            : editingNoteId && editingNoteId !== note.id
            ? 'notes-list-tab-edit-disabled'
            : '',
          disabled: editingNoteId !== null && editingNoteId === note.id,
        },
        {
          label: 'copy',
          icon: isContentCopied ? (
            <Check
              width={16}
              height={16}
              className="notes-list-tab-icon-check"
            />
          ) : (
            <Copy />
          ),
          tooltip: isContentCopied
            ? 'Note Description Copied'
            : 'Copy Note Description',
          onClick: () => handleCopyContent(note),
          // eslint-disable-next-line no-nested-ternary
          className: isContentCopied
            ? 'copied'
            : editingNoteId && editingNoteId !== note.id
            ? 'notes-list-tab-edit-disabled'
            : '',
          disabled: editingNoteId !== null && editingNoteId === note.id,
        },
        {
          label: 'edit',
          icon: <Pencil />,
          tooltip:
            // eslint-disable-next-line no-nested-ternary
            editingNoteId === String(note.id)
              ? 'Editing...'
              : editingNoteId
              ? 'Another note is being edited'
              : 'Edit Note',
          onClick:
            editingNoteId && editingNoteId !== note.id
              ? undefined
              : () => handleStartEditingNote(note),
          className:
            // eslint-disable-next-line no-nested-ternary
            editingNoteId === note.id
              ? 'notes-list-tab-edit-active'
              : editingNoteId && editingNoteId !== note.id
              ? 'notes-list-tab-edit-disabled'
              : '',
          disabled: editingNoteId !== null && editingNoteId !== note.id,
        },
        {
          label: 'delete',
          icon: <Trash />,
          tooltip: 'Delete',
          onClick: () => handleDeleteClick(note),
          disabled:
            (editingNoteId !== null && editingNoteId === note.id) ||
            (loginUserId !== undefined &&
              note.userId !== undefined &&
              loginUserId !== note.userId),
          className:
            (editingNoteId && editingNoteId !== note.id) ||
            (loginUserId !== undefined &&
              note.userId !== undefined &&
              loginUserId !== note.userId)
              ? 'notes-list-tab-edit-disabled'
              : '',
        },
        {
          label: pinnedAt ? 'unpin' : 'pin',
          icon: pinnedAt ? (
            <PinBlue
              width={16}
              height={16}
              className="notes-list-tab-icon-action-clickable-pinned"
            />
          ) : (
            <UnpinGrey width={16} height={16} />
          ),
          tooltip: pinnedAt ? 'Unpin' : 'Pin to top',
          onClick: () => handlePinToggle(note?.id, pinnedAt),
          // eslint-disable-next-line no-nested-ternary
          className: pinnedAt
            ? 'notes-list-tab-pin-icon-always-visible'
            : editingNoteId && editingNoteId !== note.id
            ? 'notes-list-tab-edit-disabled'
            : '',
          disabled: editingNoteId !== null && editingNoteId === note.id,
        },
      ];
    },
    [
      copiedNoteId,
      copiedLinkNoteId,
      handleCopyLink,
      handleCopyContent,
      handlePinToggle,
      editingNoteId,
      handleStartEditingNote,
      handleDeleteClick,
      loginUserId,
    ],
  );

  const handleEditorChange = (value: string) => {
    setEditorValue(value);
    // Extract attachment IDs from attachments array
    const attachmentIdsFromAttachments = attachments
      .map((attachment) => attachment?.attachmentId)
      .filter((id): id is number => id !== undefined && id !== null);
    // Update currentData state
    setCurrentData({
      content: value,
      visibility: selectedVisibilityKey,
      attachmentIds: attachmentIdsFromAttachments,
    });
  };

  const handleVisibilityChange = (key: string) => {
    setSelectedVisibilityKey(key);
    // Extract attachment IDs from attachments array (source of truth)
    const attachmentIdsFromAttachments = attachments
      .map((attachment) => attachment?.attachmentId)
      .filter((id): id is number => id !== undefined && id !== null);
    // Update currentData when visibility changes
    // Always use current attachments state, not prev?.attachmentIds which might be stale
    setCurrentData((prev) => ({
      content: prev?.content || editorValue,
      visibility: key,
      attachmentIds: attachmentIdsFromAttachments,
    }));
  };

  const handleSave = () => {
    setBlockedDraftText(true);
    setClickedAddNewNote(true);
    if (showDraftSavedMessage) {
      setShowDraftSavedMessage(false);
    }
    // Set flag to prevent draft save from triggering
    attachments.forEach((attachment) => {
      if (attachment.status === AttachmentUploadStatus.Uploading) {
        const attachmentMeta = attachmentsMeta.find(
          (item) =>
            item.attachmentIdentifier === attachment.attachmentIdentifier,
        );
        if (attachmentMeta?.source) {
          attachmentMeta.source.cancel('Upload has been cancelled.');
        }
      }
    });
    setIsFinalSaveInProgress(true);
    setAttachmentsMeta([]);
    // Clear currentData to prevent draft save from triggering
    setCurrentData(null);

    // Extract attachment IDs from attachments array
    const attachmentIdsFromAttachments = attachments
      .map((attachment) => attachment?.attachmentId)
      .filter((id): id is number => id !== undefined && id !== null);

    // If a draft note exists, update it with status 1 (final save)
    if (noteList?.draftNote?.id) {
      updateProspectNotesRequest({
        noteId: Number(noteList.draftNote.id),
        content: editorValue,
        visibility: selectedVisibilityKey as visibility,
        attachmentIds: attachmentIdsFromAttachments,
        status: 1,
      });
      return;
    }
    // If no draft note, create new one (status will be 1 by default)
    createProspectNote({
      prospectId: selectedProspectId,
      content:
        editorValue === '' && attachments?.length !== 0
          ? `<div></div>`
          : editorValue,
      visibility: selectedVisibilityKey as visibility,
      attachmentIds: attachmentIdsFromAttachments,
    });
  };

  const handleUpdateNoteVisibility = useCallback(
    (note: NoteItem) => {
      const toggledVisibility =
        note?.visibility === visibility.Public
          ? visibility.Private
          : visibility.Public;
      const noteId = Number(note.id);

      setNoteList((prevNoteList) => {
        if (!prevNoteList?.notes) {
          return prevNoteList;
        }

        const noteIndex = prevNoteList.notes.findIndex((n) => n.id === noteId);

        if (noteIndex === -1) {
          return prevNoteList;
        }

        const existingNote = prevNoteList.notes[noteIndex];
        const updatedNote: NoteItem = {
          ...existingNote,
          visibility: toggledVisibility,
        };

        const updatedNotes = [...prevNoteList.notes];
        updatedNotes[noteIndex] = updatedNote;

        return {
          ...prevNoteList,
          notes: updatedNotes,
        };
      });

      updateProspectNotesVisibilityRequest(noteId, {
        visibility: toggledVisibility,
      });
      setShowConfimationModal(false);
      setSelectedNoteForVisibilityChange(null);
    },
    [
      updateProspectNotesVisibilityRequest,
      setShowConfimationModal,
      setSelectedNoteForVisibilityChange,
    ],
  );

  const handleAttachmentsChange = (
    updatedAttachments: AttachmentType[],
  ): void => {
    // If editing a note, update editingNoteAttachments; otherwise update attachments (for new note)
    if (editingNoteId) {
      setEditingNoteAttachments(updatedAttachments);
    } else {
      setAttachments(updatedAttachments);
      // Note: currentData will be updated via useEffect that watches attachments state
      // This ensures we always have the latest attachment IDs even when multiple uploads complete out of order
    }
  };

  const handleAttachmentStatusChange = (updatedAttachment: AttachmentType) => {
    // If editing a note, update editingNoteAttachments; otherwise update attachments (for new note)
    if (editingNoteId) {
      setEditingNoteAttachments((prevAttachments) =>
        prevAttachments.map((attachment) =>
          attachment.attachmentIdentifier ===
          updatedAttachment.attachmentIdentifier
            ? {
                ...attachment,
                ...updatedAttachment,
                status:
                  updatedAttachment.status ||
                  AttachmentUploadStatus.UploadSuccess,
              }
            : attachment,
        ),
      );
    } else {
      setAttachments((prevAttachments) =>
        prevAttachments.map((attachment) =>
          attachment.attachmentIdentifier ===
          updatedAttachment.attachmentIdentifier
            ? {
                ...attachment,
                ...updatedAttachment,
                status:
                  updatedAttachment.status ||
                  AttachmentUploadStatus.UploadSuccess,
              }
            : attachment,
        ),
      );
    }
  };

  const getSearchIcons = (): InputIconConfig[] => {
    const icons: InputIconConfig[] = [
      {
        place: Input.IconPlace.Left,
        identifier: 'search',
      },
    ];

    if (values && values.trim().length > 0) {
      icons.push({
        place: Input.IconPlace.Right,
        identifier: 'close-o cursor-pointer',
        onClick: () => {
          setValues('');
          updateNotesSearchInUrl('');
          fetchNotesProspectList({
            taskId: selectedProspectId,
            search: '',
          });
        },
      });
    }

    return icons;
  };

  // For to check that draft note available for the first time
  useEffect(() => {
    if (noteList?.draftNote) {
      setDraftSavedForNotes(true);
    }
  }, [noteList?.draftNote]);

  // Check if content needs truncation
  useEffect(() => {
    if (!notes || notes.length === 0) {
      return;
    }

    const checkTruncation = () => {
      const needsTruncation = new Set<string>();
      Object.entries(contentRefs.current).forEach(([noteId, element]) => {
        if (element) {
          // Find only the text content element (exclude attachments)
          const textContentElement = element.querySelector(
            '.email-preview-content',
          ) as HTMLElement;

          if (textContentElement) {
            // Check if content height exceeds 120px
            // Only calculate text content height, exclude attachments
            const maxHeight = 120;
            // Check if there's meaningful content (not just empty HTML)
            const hasContent =
              textContentElement.textContent &&
              textContentElement.textContent.trim().length > 0;

            // Check if text content exceeds max height (regardless of expansion state)
            // We need to track this so we can show "See Less" when expanded
            if (hasContent && textContentElement.scrollHeight > maxHeight) {
              needsTruncation.add(noteId);
            }
          }
        }
      });
      setNotesNeedingTruncation(needsTruncation);
    };

    // Delay to ensure DOM is rendered with content
    const timeoutId = setTimeout(checkTruncation, 100);

    // Also check after images/content load
    const longerTimeoutId = setTimeout(checkTruncation, 500);

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(timeoutId);
      clearTimeout(longerTimeoutId);
    };
  }, [notes, expandedNoteIds]);

  useEffect(() => {
    const urlParams = new URLSearchParams(url?.search);
    const noteId = urlParams.get('selectedIds') || urlParams.get('noteId');
    const notesSearch = urlParams.get('search') || '';

    // Initialize search input from URL if present
    if (notesSearch) {
      setValues(notesSearch);
      // We rely on server-side search, so we don't need searchTerm for client filtering
    }

    fetchNotesProspectList({
      taskId: selectedProspectId,
      sendDraft: isInitialRenderRef.current,
      ...(noteId ? { selectedIds: [Number(noteId)] } : {}),
      ...(notesSearch ? { search: notesSearch } : {}),
    });
    // Mark as not initial render after first fetch
    if (isInitialRenderRef.current) {
      isInitialRenderRef.current = false;
    }
  }, [selectedProspectId, url?.search]);

  useEffect(() => {
    if (activeTab !== 'notes') {
      return;
    }

    if (fetchNotes && fetchNotesProspectList && selectedProspectId) {
      fetchNotesProspectList({
        taskId: selectedProspectId,
        sendDraft: true,
      });
      // Reset the flag
      onNoteChange?.(false);
    }
  }, [
    fetchNotes,
    fetchNotesProspectList,
    selectedProspectId,
    onNoteChange,
    activeTab,
  ]);

  // Reset last processed note params when prospect changes (so new prospect's noteId in URL is highlighted)
  useEffect(() => {
    lastProcessedNoteParamsFromUrlRef.current = null;
  }, [selectedProspectId]);

  // Handle highlighting notes based on selectedIds or noteId from URL (only once per params per prospect, like email lastProcessedEmailIdFromUrlRef)
  useEffect(() => {
    if (!notes?.length) return;

    const urlParams = new URLSearchParams(url?.search);
    const selectedIdsParam = urlParams.get('selectedIds');
    const noteIdParam = urlParams.get('noteId');

    if (!selectedIdsParam && !noteIdParam) return;

    // Parse IDs from URL params
    const parseIds = (param: string | null): string[] => {
      if (!param) return [];
      return param
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
        .map(String);
    };

    const idsToHighlight = [
      ...parseIds(selectedIdsParam),
      ...(noteIdParam ? [String(noteIdParam.trim())] : []),
    ];

    if (!idsToHighlight.length) return;

    const paramsKey = [...idsToHighlight].sort().join(',');
    // Only process if we haven't already highlighted these params for this prospect (prevents re-highlight on tab change / actions)
    if (lastProcessedNoteParamsFromUrlRef.current === paramsKey) return;

    // Find matching notes
    const matchingNoteIds = new Set(
      notes
        .filter((note) => idsToHighlight.includes(String(note.id)))
        .map((note) => String(note.id)),
    );

    if (!matchingNoteIds.size) return;

    lastProcessedNoteParamsFromUrlRef.current = paramsKey;
    setHighlightedNoteIds(matchingNoteIds);

    // Scroll to first highlighted note (only once)
    const firstHighlightedId = Array.from(matchingNoteIds)[0];
    const scrollTimeoutId = setTimeout(() => {
      const noteElement = contentRefs.current[firstHighlightedId]?.closest(
        '.notes-list-tab-user-details-container',
      ) as HTMLElement;
      noteElement?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }, 200);

    // Remove highlight and noteId/selectedIds from URL after 2 seconds
    const highlightTimeoutId = setTimeout(() => {
      setHighlightedNoteIds(new Set());
      removeNoteIdFromUrl();
    }, 2000);

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(scrollTimeoutId);
      clearTimeout(highlightTimeoutId);
    };
  }, [notes, removeNoteIdFromUrl]);

  // If we receive a draft note, pre-fill the editor and visibility
  useEffect(() => {
    const draftNote = noteList?.draftNote;
    if (draftNote) {
      const draftContent = draftNote.content || '';
      const draftVisibility = draftNote.visibility || 'public';
      // Extract all attachment IDs from draft note attachments
      const draftAttachmentIds =
        draftNote.attachments && draftNote.attachments.length > 0
          ? draftNote.attachments
              .map((attachment) => attachment?.id)
              .filter((id): id is number => id !== undefined && id !== null)
          : [];

      // Transform draft note attachments to AttachmentType format for editor display
      const transformedAttachments: AttachmentType[] =
        draftNote.attachments && draftNote.attachments.length > 0
          ? draftNote.attachments.map((attachment) => {
              const sizeNumber = attachment?.size
                ? parseInt(String(attachment.size), 10)
                : 0;
              const attachmentIdString =
                attachment?.id !== undefined &&
                attachment?.id !== null &&
                String(attachment.id);
              return {
                attachmentId: attachment?.id,
                attachmentIdentifier: attachmentIdString,
                status: AttachmentUploadStatus.Existing, // Existing attachments should have Existing status
                file: {
                  name: attachment?.name || '',
                  type: attachment?.mimeType || '',
                  size: sizeNumber,
                },
                attachmentSize: sizeNumber,
              };
            })
          : [];

      // Set previousData first to prevent triggering draft save when editor value is set
      const draftData = {
        content: draftContent,
        visibility: draftVisibility,
        attachmentIds: draftAttachmentIds,
      };
      setPreviousData(draftData);

      // Then set editor value and visibility
      setEditorValue(draftContent);
      setSelectedVisibilityKey(draftVisibility);

      // Only restore attachments if current attachments state is empty (initial restoration)
      // This prevents overwriting attachments that were added but not yet saved to draft
      // Use functional update to access current attachments value
      setAttachments((prevAttachments) => {
        // If no current attachments, restore from draft
        if (prevAttachments.length === 0) {
          return transformedAttachments;
        }
        // If we have current attachments, merge: keep existing and add any from draft that aren't already present
        const existingAttachmentIds = new Set(
          prevAttachments
            .map((att) => att.attachmentId)
            .filter((id): id is number => id !== null && id !== undefined),
        );
        const newAttachmentsFromDraft = transformedAttachments.filter(
          (att) =>
            att.attachmentId && !existingAttachmentIds.has(att.attachmentId),
        );
        // Only update if there are new attachments to add
        if (newAttachmentsFromDraft.length > 0) {
          return [...prevAttachments, ...newAttachmentsFromDraft];
        }
        // Return current attachments unchanged if no new ones to add
        return prevAttachments;
      });

      // Set currentData to match, but this won't trigger save because previousData matches
      setCurrentData(draftData);
    } else {
      // Clear editor when no draftNote is present
      setEditorValue('');
      setPreviousData(null);
      setCurrentData(null);
      setAttachments([]);
    }
  }, [noteList?.draftNote]);

  // Reset Create Notes List
  useEffect(() => {
    if (activeTab !== 'notes') {
      return;
    }

    executeOnRequestStatus({
      status: createProspectNoteRequestStatus,
      onSuccess: () => {
        // Check if this is a draft save (status 0) by checking if currentData exists and final save is not in progress
        if (currentData && !noteList?.draftNote && !isFinalSaveInProgress) {
          const draftNote = createProspectNoteResponse;

          if (draftNote) {
            // Ensure draft note has content from currentData if API response doesn't have it
            const draftNoteWithContent = {
              ...draftNote,
              content: draftNote.content || currentData.content,
              visibility:
                draftNote.visibility || (currentData.visibility as visibility),
            };

            setNoteList((prevNoteList) => ({
              ...prevNoteList,
              draftNote: draftNoteWithContent,
            }));

            // Update previousData to match what was saved
            // Use attachment IDs from attachments state (source of truth) to ensure we have all IDs
            const savedAttachmentIds = attachments
              .map((attachment) => attachment?.attachmentId)
              .filter((id): id is number => id !== undefined && id !== null);
            setPreviousData({
              content: draftNoteWithContent.content || currentData.content,
              visibility:
                draftNoteWithContent.visibility || currentData.visibility,
              attachmentIds: savedAttachmentIds,
            });
            setDraftSavedForNotes(true);
            // Don't update editor value here to prevent triggering handleEditorChange
            // The editor already has the correct value
          }

          resetCreateProspectNotesListRequests();
          return;
        }
        setIsFinalSaveInProgress(false);
        resetCreateProspectNotesListRequests();

        if (createProspectNoteResponse?.id) {
          setNoteList((prevNoteList) => {
            if (!prevNoteList) {
              return {
                notes: [createProspectNoteResponse],
                pagination: {
                  skip: 0,
                  take: 20,
                  hasMore: false,
                },
                draftNote: null,
              };
            }

            const noteExists = prevNoteList.notes?.some(
              (note) => note.id === createProspectNoteResponse.id,
            );

            if (noteExists) {
              return prevNoteList;
            }

            return {
              ...prevNoteList,
              notes: [
                createProspectNoteResponse,
                ...(prevNoteList.notes || []),
              ],
            };
          });
        } else {
          fetchNotesProspectList({ taskId: selectedProspectId });
          toaster.error(
            'Note created but response was invalid. Refreshing...',
            {
              theme: Theme.New,
            },
          );
        }
        setDraftSavedForNotes(false);

        editProspectAcitivityCount({
          ...prospectActivityCount,
          notes:
            prospectActivityCount?.notes >= 0
              ? (Number(prospectActivityCount?.notes) || 0) + 1
              : 1,
        });

        setEditorValue('');
        setBlockedDraftText(false);
        setPreviousData(null);
        setCurrentData(null);
        setAttachments([]);
        setAttachmentsMeta([]);
        toaster.success(`${createProspectNoteRequestMessage}`);
        onActivityChange?.(true);
        setClickedAddNewNote(false);
        // onTaskChange?.(true);
      },
      onFailed: () => {
        setIsFinalSaveInProgress(false);
        resetCreateProspectNotesListRequests();
        setAttachmentsMeta([]);
        fetchNotesProspectList({ taskId: selectedProspectId });
        setPreviousData(currentData);
        toaster.error('Failed to create note. Please try again.', {
          theme: Theme.New,
        });
        setClickedAddNewNote(false);
      },
    });
  }, [
    createProspectNoteRequestStatus,
    onActivityChange,
    activeTab,
    setClickedAddNewNote,
    clickedAddNewNote,
    prospectActivityCount,
    editProspectAcitivityCount,
  ]);

  // Reset Delete Note List
  useEffect(() => {
    executeOnRequestStatus({
      status: deleteProspectNotesRequestsStatus?.status,
      onSuccess: () => {
        resetDeleteProspectNoteRequests();
        toaster.success(`${deleteProspectNotesRequestsStatus?.message}`);
        onActivityChange?.(true);
        editProspectAcitivityCount({
          ...prospectActivityCount,
          notes:
            prospectActivityCount?.notes >= 0
              ? (Number(prospectActivityCount?.notes) || 0) - 1
              : 0,
        });
      },
      onFailed: () => {
        resetDeleteProspectNoteRequests();
      },
    });
  }, [
    deleteProspectNotesRequestsStatus?.status,
    selectedProspectId,
    onActivityChange,
    prospectActivityCount,
    editProspectAcitivityCount,
  ]);

  // Reset get prospect notes list
  useEffect(() => {
    executeOnRequestStatus({
      status: getProspectNotesRequestStatus,
      onSuccess: () => {
        if (prospectNotesListingResponse) {
          // Check if this is a pagination request (skip > 0) or initial load (skip === 0)
          const isPaginationRequest =
            prospectNotesListingResponse.pagination?.skip > 0;

          if (isPaginationRequest) {
            // Append new notes to existing notes for pagination
            setNoteList((prevNoteList) => {
              if (prevNoteList?.notes) {
                return {
                  ...prospectNotesListingResponse,
                  draftNote:
                    prevNoteList.draftNote ??
                    prospectNotesListingResponse?.draftNote ??
                    null,
                  notes: [
                    ...prevNoteList.notes,
                    ...prospectNotesListingResponse.notes,
                  ],
                };
              }
              // Fallback to new response if prevNoteList is null
              return prospectNotesListingResponse;
            });
          } else {
            // Replace the entire list for initial load (skip === 0)
            setNoteList(prospectNotesListingResponse);
          }
        }
        resetGetProspectNotesRequests();
        setSelectedVisibilityKey('public');
      },
      onFailed: () => {
        resetGetProspectNotesRequests();
      },
    });
  }, [getProspectNotesRequestStatus, prospectNotesListingResponse]);

  useEffect(() => {
    executeOnRequestStatus({
      status: getProspectNotesPinRequestStatus,
      onSuccess: () => {
        toaster.success(getProspectNotesPinRequestMessage, {
          theme: Theme.New,
        });
        resetProspectNotePinRequests();
        onActivityChange?.(true);
      },
      onFailed: () => {
        fetchNotesProspectList({ taskId: selectedProspectId, sendDraft: true });
        resetProspectNotePinRequests();
        toaster.error('Failed to pin/unpin note. Please try again.', {
          theme: Theme.New,
        });
      },
    });
  }, [
    getProspectNotesPinRequestStatus,
    selectedProspectId,
    fetchNotesProspectList,
    resetProspectNotePinRequests,
    onActivityChange,
  ]);

  useEffect(() => {
    executeOnRequestStatus({
      status: getUpdateProspectNoteVisibiityRequestStatus,
      onSuccess: () => {
        if (updateProspectNoteVisibilityResponse) {
          const noteId = updateProspectNoteVisibilityResponse.id;

          setNoteList((prevNoteList) => {
            if (!prevNoteList?.notes) {
              return prevNoteList;
            }

            const noteIndex = prevNoteList.notes.findIndex(
              (note) => note.id === noteId,
            );

            if (noteIndex === -1) {
              return prevNoteList;
            }

            const updatedNotes = [...prevNoteList.notes];
            updatedNotes[noteIndex] = updateProspectNoteVisibilityResponse;

            return {
              ...prevNoteList,
              notes: updatedNotes,
            };
          });
        }
        toaster.success('Note visibility updated successfully.');
        resetUpdateProspectNoteVisibilityRequest();
        onActivityChange?.(true);
      },
      onFailed: () => {
        fetchNotesProspectList({ taskId: selectedProspectId, sendDraft: true });
        toaster.error('Failed to update note visibility.');
        resetUpdateProspectNoteVisibilityRequest();
      },
    });
  }, [
    getUpdateProspectNoteVisibiityRequestStatus,
    updateProspectNoteVisibilityResponse,
    selectedProspectId,
    fetchNotesProspectList,
    resetUpdateProspectNoteVisibilityRequest,
    onActivityChange,
  ]);

  // Keep currentData.attachmentIds in sync with attachments state
  // This ensures we always have the latest attachment IDs even when multiple uploads complete out of order
  useEffect(() => {
    if (!editingNoteId) {
      // Extract all attachment IDs from current attachments state (source of truth)
      const allAttachmentIds = attachments
        .map((attachment) => attachment?.attachmentId)
        .filter((id): id is number => id !== undefined && id !== null);

      // Update currentData to reflect current attachments state
      // Use functional update to avoid overwriting other fields
      setCurrentData((prev) => {
        // Only update if attachment IDs have actually changed to avoid unnecessary re-renders
        const prevAttachmentIds = prev?.attachmentIds || [];
        const attachmentIdsChanged =
          prevAttachmentIds.length !== allAttachmentIds.length ||
          !prevAttachmentIds.every(
            (id, index) => id === allAttachmentIds[index],
          );

        if (!attachmentIdsChanged && prev) {
          return prev; // No change, return previous state
        }

        return {
          content: prev?.content || editorValue,
          visibility: prev?.visibility || selectedVisibilityKey,
          attachmentIds: allAttachmentIds,
        };
      });
    }
  }, [attachments, editingNoteId, editorValue, selectedVisibilityKey]);

  // Handle attachment deletion when editing a note
  useEffect(() => {
    if (!editingNoteId || !deletedAttachmentId) {
      return;
    }

    // Capture deletedAttachmentId in a const to avoid stale closure issues
    const attachmentIdToDelete = deletedAttachmentId;

    executeOnRequestStatus({
      status: deleteAttachmentRequestStatus,
      onSuccess: () => {
        // Remove the deleted attachment from editingNoteAttachments
        setEditingNoteAttachments((prevAttachments) => {
          // Ensure we have attachments to filter
          if (!prevAttachments || prevAttachments.length === 0) {
            return prevAttachments;
          }
          // Filter out only the deleted attachment
          return prevAttachments.filter(
            (attachment) => attachment.attachmentId !== attachmentIdToDelete,
          );
        });
        handleResetDeleteAttachmentRequest();
      },
      onFailed: () => {
        if (deleteAttachmentRequestError) {
          toaster.error(deleteAttachmentRequestError.message, {
            theme: Theme.New,
          });
        }
        handleResetDeleteAttachmentRequest();
      },
    });
  }, [
    deleteAttachmentRequestStatus,
    deletedAttachmentId,
    editingNoteId,
    handleResetDeleteAttachmentRequest,
  ]);

  useEffect(() => {
    if (activeTab !== 'notes') {
      return;
    }

    executeOnRequestStatus({
      status: updateProspectNoteRequestState?.status,
      onSuccess: () => {
        if (clickedAddNewNote) {
          editProspectAcitivityCount({
            ...prospectActivityCount,
            notes:
              prospectActivityCount?.notes >= 0
                ? (Number(prospectActivityCount?.notes) || 0) + 1
                : 1,
          });
        }
        // Check if this is a draft save (status 0) by checking:
        // 1. currentData exists (main editor has content)
        // 2. draft note exists (there's a draft being edited)
        // 3. final save is not in progress
        // 4. NOT editing an existing note (editingNoteId should be null for draft saves)
        if (
          currentData &&
          noteList?.draftNote &&
          !isFinalSaveInProgress &&
          !editingNoteId
        ) {
          // Auto-save with status 0: update local draft note instead of fetching
          setNoteList((prevNoteList) => {
            if (!prevNoteList?.draftNote) return prevNoteList;

            // Filter attachments to only include those whose IDs are in currentData.attachmentIds
            const updatedAttachments =
              prevNoteList.draftNote.attachments?.filter((attachment) =>
                currentData.attachmentIds?.includes(attachment?.id),
              ) || [];

            // Update existing draft note with new content
            const updatedDraftNote: NoteItem = {
              ...prevNoteList.draftNote,
              content: currentData.content,
              visibility: currentData.visibility as visibility,
              attachments: updatedAttachments,
              updatedAt: new Date().toISOString(),
            };
            return {
              ...prevNoteList,
              draftNote: updatedDraftNote,
            };
          });

          // Update previousData to match what was saved
          // Use attachment IDs from attachments state (source of truth) to ensure we have all IDs
          const savedAttachmentIds = attachments
            .map((attachment) => attachment?.attachmentId)
            .filter((id): id is number => id !== undefined && id !== null);
          setPreviousData({
            content: currentData.content,
            visibility: currentData.visibility,
            attachmentIds: savedAttachmentIds,
          });
          setDraftSavedForNotes(true);
          resetUpdateProspectNote();
          return;
        }
        setIsFinalSaveInProgress(false);

        if (editingNoteId && updateProspectNoteResponse) {
          const noteIdToUpdate = Number.parseInt(editingNoteId, 10);

          if (Number.isNaN(noteIdToUpdate)) {
            fetchNotesProspectList({
              taskId: selectedProspectId,
              sendDraft: true,
            });
            setEditingNoteId(null);
            return;
          }

          setNoteList((prevNoteList) => {
            if (!prevNoteList?.notes) {
              return prevNoteList;
            }

            const noteIndex = prevNoteList.notes.findIndex(
              (note) => note.id === noteIdToUpdate,
            );

            if (noteIndex === -1) {
              return {
                ...prevNoteList,
                notes: [
                  updateProspectNoteResponse,
                  ...(prevNoteList.notes || []),
                ],
              };
            }

            const updatedNotes = [...prevNoteList.notes];
            updatedNotes[noteIndex] = updateProspectNoteResponse;

            return {
              ...prevNoteList,
              notes: updatedNotes,
            };
          });
        } else if (
          noteList?.draftNote?.id &&
          isFinalSaveInProgress &&
          updateProspectNoteResponse
        ) {
          setNoteList((prevNoteList) => {
            if (!prevNoteList?.draftNote) {
              return prevNoteList;
            }

            const draftNoteId = prevNoteList.draftNote.id;
            const existingNoteIndex =
              prevNoteList.notes?.findIndex(
                (note) => note.id === draftNoteId,
              ) ?? -1;

            if (existingNoteIndex >= 0) {
              const updatedNotes = [...(prevNoteList.notes || [])];
              updatedNotes[existingNoteIndex] = updateProspectNoteResponse;
              return {
                ...prevNoteList,
                notes: updatedNotes,
                draftNote: null,
              };
            }
            return {
              ...prevNoteList,
              notes: [
                updateProspectNoteResponse,
                ...(prevNoteList.notes || []),
              ],
              draftNote: null,
            };
          });
        } else if (updateProspectNoteResponse) {
          setNoteList((prevNoteList) => {
            if (!prevNoteList?.notes) {
              return {
                notes: [updateProspectNoteResponse],
                pagination: {
                  skip: 0,
                  take: 20,
                  hasMore: false,
                },
                draftNote: null,
              };
            }

            const noteIndex = prevNoteList.notes.findIndex(
              (note) => note.id === updateProspectNoteResponse.id,
            );

            if (noteIndex >= 0) {
              const updatedNotes = [...prevNoteList.notes];
              updatedNotes[noteIndex] = updateProspectNoteResponse;
              return {
                ...prevNoteList,
                notes: updatedNotes,
              };
            }
            return {
              ...prevNoteList,
              notes: [updateProspectNoteResponse, ...prevNoteList.notes],
            };
          });
        }
        // If neither condition is met, we don't refetch - the note should already be in the list
        toaster.success(
          `${
            clickedAddNewNote
              ? 'Note created successfully'
              : updateProspectNoteRequestState?.message
          }`,
        );
        setBlockedDraftText(false);
        setDraftSavedForNotes(false);
        setEditingNoteId(null);
        setAttachments([]);
        setEditorValue('');
        setEditingNoteAttachments([]);
        setAttachmentsMeta([]);
        setEditingNoteAttachmentsMeta([]);
        setCurrentData(null);
        setPreviousData(null);
        resetUpdateProspectNote();
        onActivityChange?.(true);
        onTaskChange?.(true);
        setClickedAddNewNote(false);
      },
      onFailed: () => {
        setIsFinalSaveInProgress(false);
        fetchNotesProspectList({ taskId: selectedProspectId, sendDraft: true });
        setPreviousData(currentData);
        resetUpdateProspectNote();
        setAttachmentsMeta([]);
        if (editingNoteId) {
          setEditingNoteId(null);
          setEditingNoteAttachmentsMeta([]);
        }
        toaster.error('Failed to update note. Please try again.', {
          theme: Theme.New,
        });
        setClickedAddNewNote(false);
      },
    });
  }, [
    updateProspectNoteRequestState?.status,
    selectedProspectId,
    currentData,
    noteList?.draftNote,
    onActivityChange,
    editingNoteId,
    isFinalSaveInProgress,
    activeTab,
    updateProspectNoteResponse,
    fetchNotesProspectList,
    resetUpdateProspectNote,
    onTaskChange,
    prospectActivityCount,
    editProspectAcitivityCount,
    setClickedAddNewNote,
    clickedAddNewNote,
  ]);

  useEffect(() => {
    // Don't handle deletion here if we're editing a note (that's handled in the effect above)
    if (editingNoteId) {
      return;
    }

    executeOnRequestStatus({
      status: deleteAttachmentRequestStatus,
      onSuccess: () => {
        const updatedAttachments = attachments.filter(
          (item) => item.attachmentId !== deletedAttachmentId,
        );

        handleAttachmentsChange?.(updatedAttachments);
        toaster.success(t('messages.attachment_removed_successfully'), {
          theme: Theme.New,
        });
        updateProspectNotesRequest({
          noteId: Number(noteList?.draftNote?.id),
          content: currentData?.content || editingNoteValue,
          visibility: (currentData?.visibility ||
            selectedVisibilityKey) as visibility,
          attachmentIds: updatedAttachments
            ?.map((att) => att?.attachmentId)
            ?.filter((id): id is number => id !== undefined && id !== null),
          status: 0,
        });
        handleResetDeleteAttachmentRequest?.();
      },
      onFailed: () => {
        if (deleteAttachmentRequestError) {
          toaster.error(deleteAttachmentRequestError.message, {
            theme: Theme.New,
          });
        }
      },
    });
  }, [deleteAttachmentRequestStatus, editingNoteId]);

  if (activeTab !== 'notes') {
    return null;
  }

  // Show skeleton only on initial load (when no notes exist), not during pagination
  const isInitialLoad =
    getIsRequestPending(getProspectNotesRequestStatus) &&
    (!noteList?.notes || noteList.notes.length === 0);

  if (isInitialLoad) {
    return <NotesListTabSkeleton planCode={planCode} />;
  }
  return (
    <div className="notes-list-tab-container" ref={scrollContainerRef}>
      <InlineMentionEditor
        key={`editor-${activeTab}`}
        value={editorValue}
        onEditorChange={(value) => handleEditorChange(value)}
        showAddAttachments={true}
        showToolBarContainer={true}
        showFooterToolbarContainer={true}
        showFooterVisibilitySelector={true}
        showFooterSaveButton={true}
        onFooterSave={handleSave}
        selectedVisibilityKey={selectedVisibilityKey}
        onVisibilityChange={handleVisibilityChange}
        isFooterSaveButtonDisabled={
          (!editorValue?.trim() && attachments?.length === 0) ||
          getIsRequestPending(uploadAttachmentRequestStatus) ||
          getIsRequestPending(updateProspectNoteRequestState?.status) ||
          getIsRequestPending(createProspectNoteRequestStatus) ||
          showError?.length > 0
        }
        placeholder={
          selectedVisibilityKey === visibility.Private
            ? 'Visible only to you and people tagged here'
            : 'Visible to everyone in the organisation*'
        }
        saveButtonText="Add Note"
        attachments={attachments}
        onAttachmentsChange={handleAttachmentsChange}
        onAttachmentStatusChange={handleAttachmentStatusChange}
        sendAttachmentUploadRequest={handleSendAttachmentUploadRequest}
        uploadAttachmentRequestStatus={uploadAttachmentRequestStatus}
        uploadAttachmentRequestError={uploadAttachmentRequestError}
        uploadedAttachment={uploadedAttachment}
        resetUploadAttachmentRequest={handleResetUploadAttachmentRequest}
        sendDeleteAttachmentRequest={handleSendDeleteAttachmentRequest}
        deleteAttachmentRequestStatus={deleteAttachmentRequestStatus}
        deleteAttachmentRequestError={deleteAttachmentRequestError}
        deletedAttachmentId={deletedAttachmentId}
        resetDeleteAttachmentRequest={handleResetDeleteAttachmentRequest}
        onAttachmentsMetaChange={(meta) => {
          setAttachmentsMeta(meta || []);
        }}
        attachmentMsg={true}
        uniqueId={selectedProspectId || 0}
        attachmentsClassname="notes-list-tab-attachment"
        notesTabAttachment={true}
        autoFocus={!(values?.length > 0)}
        error={showError?.length > 0}
        errorMessage={showError}
        updateNoteRequestStatus={updateProspectNoteRequestState?.status}
        createNoteRequestStatus={createProspectNoteRequestStatus}
        blockedDraftText={blockedDraftText}
        showDraftStatus={true}
        showDraftSavedMessage={showDraftSavedMessage}
        setShowDraftSavedMessage={setShowDraftSavedMessage}
      />
      <div className="notes-list-tab-body-container">
        {planCode !== SubscriptionPlans.FREE && (
          <div className="notes-list-tab-search-input">
            <Input
              placeholder="Search notes details"
              icons={getSearchIcons()}
              value={values}
              onChange={(value) => setValues(value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const trimmed = values.trim();
                  updateNotesSearchInUrl(trimmed);
                  fetchNotesProspectList({
                    taskId: selectedProspectId,
                    search: trimmed,
                  });
                }
              }}
            />
          </div>
        )}
        {fetchDataAsPerView?.length === 0 ? (
          values?.length > 0 ? (
            <NoProspectDetailResultScreen
              title=" No matching notes found"
              description="There are no notes that match your search. Try a different keyword."
              imageSrc={Images.NoProspectNote}
            />
          ) : (
            <NoProspectDetailResultScreen
              title="No Notes Yet"
              description="Start by adding your first note."
              imageSrc={Images.NoProspectNote}
            />
          )
        ) : (
          <div className="notes-list-tab-user-messages">
            {fetchDataAsPerView?.map((note) => {
              const iconConfig = getIconConfig(note);
              const isEditing = editingNoteId === note.id;
              const isHighlighted = highlightedNoteIds.has(String(note.id));
              return (
                <div
                  className={`notes-list-tab-user-details-container ${
                    isEditing ? 'notes-list-tab-editing-active' : ''
                  } ${isHighlighted ? 'notes-list-tab-highlighted' : ''}`}
                  key={String(note.id)}
                  data-note-id={String(note.id)}
                >
                  <span className="notes-tab-user-profile">
                    {note.authorInitials}
                  </span>
                  <div className="notes-list-tab-user-details">
                    <div className="notes-list-tab-details-header">
                      <div className="notes-list-tab-user-detail-name-header">
                        <span className="notes-list-tab-user-name">
                          {note?.user?.firstName} {note?.user?.lastName}
                        </span>
                        <Dot className="notes-tab-list-dot-icon" />
                        {note?.editedAt && (
                          <span className="notes-list-tab-edited">Edited</span>
                        )}
                        {note?.editedAt ? (
                          <OverlayTooltip
                            text={`Edited By ${note?.user?.firstName} ${
                              note?.user?.lastName
                            } at ${formatDateTimeWithUserTimezone(
                              note?.editedAt,
                              userTimezone,
                            )}`}
                          >
                            <span className="notes-list-tab-user-details-time">
                              {formatNoteTimestamp(
                                note?.editedAt,
                                false,
                                userTimezone,
                              )}
                            </span>
                          </OverlayTooltip>
                        ) : (
                          <OverlayTooltip
                            text={formatNoteTimestamp(
                              note?.createdAt,
                              true,
                              userTimezone,
                            )}
                          >
                            <span className="notes-list-tab-user-details-time">
                              {formatNoteTimestamp(
                                note?.createdAt,
                                false,
                                userTimezone,
                              )}
                            </span>
                          </OverlayTooltip>
                        )}
                        {note?.taskId && (
                          <>
                            <Dot className="notes-tab-list-dot-icon" />
                            <OverlayTooltip
                              text={`Note for "${
                                note?.task?.title || 'Custom Task'
                              }" task ${
                                note?.sequence?.title
                                  ? `in "${note?.sequence?.title}" sequence`
                                  : ''
                              }`}
                            >
                              <span
                                className="notes-tab-list-checkox-container"
                                {...accessibleOnClick(() =>
                                  handleTaskNoteClick({
                                    ...note,
                                    id: Number(note.id),
                                  }),
                                )}
                              >
                                {getStepIcon({
                                  type: note?.task?.type as any,
                                  width: 16,
                                  height: 16,
                                  module: 'tasks-columns',
                                })}
                              </span>
                            </OverlayTooltip>
                          </>
                        )}
                      </div>
                      <div className="notes-list-tab-header-action-btn">
                        {iconConfig?.map((opt) => {
                          const isDisabled =
                            opt?.disabled === true ||
                            getIsRequestPending(
                              getProspectNotesPinRequestStatus,
                            );
                          const hasOnClick = opt?.onClick && !isDisabled;
                          return (
                            <OverlayTooltip
                              key={`${note?.id}-${opt?.label}`}
                              text={opt?.tooltip}
                            >
                              <span
                                className={`notes-list-tab-icon-action ${
                                  opt?.className || ''
                                }`}
                                {...(hasOnClick
                                  ? accessibleOnClick(opt?.onClick)
                                  : {})}
                                role={hasOnClick ? 'button' : undefined}
                                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                                tabIndex={hasOnClick ? 0 : undefined}
                                onKeyDown={(e) => {
                                  if (
                                    hasOnClick &&
                                    (e.key === 'Enter' || e.key === ' ')
                                  ) {
                                    e.preventDefault();
                                    opt?.onClick?.();
                                  }
                                }}
                              >
                                {opt?.icon}
                              </span>
                            </OverlayTooltip>
                          );
                        })}
                        <OverlayTooltip
                          text={
                            note?.visibility === visibility.Public
                              ? 'Currently public. Click to make it private.'
                              : 'Currently private. Click to make it public.'
                          }
                        >
                          <span
                            {...accessibleOnClick(() => {
                              const originalNote = noteList?.notes?.find(
                                (n) => String(n.id) === note.id,
                              );
                              if (originalNote) {
                                openVisibilityModal(originalNote);
                              }
                            })}
                          >
                            {note?.visibility === visibility.Public ? (
                              <LockOpen className="green-txt-16" />
                            ) : (
                              <Lock className="yellow-txt-13" />
                            )}
                          </span>
                        </OverlayTooltip>
                      </div>
                    </div>
                    <div className="notes-list-tab-details-text">
                      {editingNoteId === String(note.id) ? (
                        <div className="notes-list-tab-edit-wrapper">
                          <InlineMentionEditor
                            value={editingNoteValue}
                            onEditorChange={(value) =>
                              setEditingNoteValue(value)
                            }
                            showAddAttachments={true}
                            showFooterToolbarContainer={true}
                            showToolBarContainer={true}
                            showFooterSaveButton={true}
                            onFooterSave={handleSaveEditedNote}
                            isFooterSaveButtonDisabled={
                              (!editingNoteValue?.trim() &&
                                editingNoteAttachments?.length === 0) ||
                              getIsRequestPending(
                                updateProspectNoteRequestState?.status,
                              ) ||
                              getIsRequestPending(
                                uploadAttachmentRequestStatus,
                              ) ||
                              showError?.length > 0
                            }
                            saveButtonText="Save"
                            showFooterCancelButton
                            onFooterCancel={handleCancelEditing}
                            attachments={editingNoteAttachments}
                            onAttachmentsChange={handleAttachmentsChange}
                            onAttachmentStatusChange={
                              handleAttachmentStatusChange
                            }
                            sendAttachmentUploadRequest={
                              handleSendAttachmentUploadRequest
                            }
                            uploadAttachmentRequestStatus={
                              uploadAttachmentRequestStatus
                            }
                            uploadAttachmentRequestError={
                              uploadAttachmentRequestError
                            }
                            uploadedAttachment={uploadedAttachment}
                            resetUploadAttachmentRequest={
                              handleResetUploadAttachmentRequest
                            }
                            sendDeleteAttachmentRequest={
                              handleSendDeleteAttachmentRequest
                            }
                            deleteAttachmentRequestStatus={
                              deleteAttachmentRequestStatus
                            }
                            deleteAttachmentRequestError={
                              deleteAttachmentRequestError
                            }
                            deletedAttachmentId={deletedAttachmentId}
                            resetDeleteAttachmentRequest={
                              handleResetDeleteAttachmentRequest
                            }
                            onAttachmentsMetaChange={(meta) => {
                              setEditingNoteAttachmentsMeta(meta || []);
                            }}
                            uniqueId={editingNoteId && Number(editingNoteId)}
                            attachmentsClassname="notes-list-tab-edit-attachment"
                            notesTabAttachment={true}
                            error={showError?.length > 0}
                            autoFocus
                            errorMessage={showError}
                            blockedDraftText={blockedDraftText}
                            showDraftSavedMessage={showDraftSavedMessage}
                            setShowDraftSavedMessage={setShowDraftSavedMessage}
                          />
                        </div>
                      ) : (
                        <>
                          <span
                            className={`notes-list-tab-user-note-content ${
                              expandedNoteIds.has(note.id)
                                ? ''
                                : 'notes-list-tab-content-truncated'
                            }`}
                          >
                            <div
                              ref={(el) => {
                                contentRefs.current[note.id] = el;
                              }}
                            >
                              <EmailPreviewContent
                                content={note?.content}
                                attachments={note?.attachments}
                              />
                            </div>
                          </span>
                          {notesNeedingTruncation?.has(note.id) && (
                            <button
                              type="button"
                              className="notes-list-tab-see-more-btn"
                              onClick={() => toggleNoteExpansion(note.id)}
                              {...accessibleOnClick(() =>
                                toggleNoteExpansion(note.id),
                              )}
                            >
                              {expandedNoteIds.has(note?.id)
                                ? 'See Less'
                                : 'See More'}
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}

            {isLoadingMoreNotes && (
              <div className="notes-list-tab-loading">
                <Spinner className="spinner--blue" animation="border" />
              </div>
            )}
            {noteList?.pagination?.hasMore === false &&
              notes &&
              notes?.length > 15 && (
                <div className="notes-list-tab-end-divider">
                  <span>The End</span>
                </div>
              )}
          </div>
        )}
      </div>
      {selectedNoteForVisibilityChange && (
        <ConfirmationModal
          show={showConfimationModal}
          onClose={() => {
            setShowConfimationModal(false);
            setSelectedNoteForVisibilityChange(null);
          }}
          customHeaderText={
            selectedNoteForVisibilityChange?.visibility === visibility.Public
              ? 'Make this note private?'
              : 'Make this note public?'
          }
          CustomContent={
            selectedNoteForVisibilityChange?.visibility ===
            visibility.Public ? (
              <span>
                <div>
                  This note will no longer be visible to your organisation.
                </div>
                <div className="mt-3">
                  Only you will have access to it. Would you like to make it
                  private?
                </div>
              </span>
            ) : (
              <span>
                <div>
                  This note will be visible to all members of your organization.
                </div>
                <div className="mt-3">Would you like to make it public?</div>
              </span>
            )
          }
          onSubmit={() =>
            handleUpdateNoteVisibility(selectedNoteForVisibilityChange)
          }
        />
      )}
      {showDeleteModal && notePendingDelete && (
        <ConfirmationModal
          show={showDeleteModal}
          onClose={handleCloseDeleteModal}
          customClassName="note-delete-confirmation-modal"
          CustomHeaderIcon={
            <Trash width={24} height={24} className="trash-icon" />
          }
          customHeaderText="Are you sure you want to delete this note?"
          CustomContent="Once deleted, this note cannot be restored."
          onSubmit={handleNoteDelete}
        />
      )}
    </div>
  );
};
export default NotesListTab;
